import { postapicallnetworkservice } from '../apicallservice'
/**
 * SUBMIT RESAON
 */
export const Fetchrvpholdshipmenttobereturned = async (payload, sendResult) => {
  let apiendpoint = `/api/shipments/to-be-returned`;
  let resultData = await postapicallnetworkservice('POST', apiendpoint, payload);
  sendResult(resultData)
};


//////////////////
// WEBPACK FOOTER
// ./services/modules/rvpholdreturnservices.js
// module id = 1601
// module chunks = 1